// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import { color, xScreen } from "@bg/XDL/Utilities";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const stickyMode = css`
    ${xScreen("lte", "md")} {
        position: sticky;
        left: 0;
        z-index: 2;
        background-clip: padding-box;
        box-shadow: 0 2px 9px -2px ${color("common.black.main", 0.12)};
    }
`;

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        cssOverrides: {
            header: css`
                background: ${getColor("text.main")};
                width: auto;
                text-align: left;
                text-transform: capitalize;
                border: 0;
                height: 38px;

                span {
                    color: ${getColor("common.white")};
                    text-transform: capitalize;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 0.2px;
                    line-height: 22px;
                }

                > button {
                    justify-content: flex-start;
                }
            `,
            body: css`
                box-shadow: 0 0 15px 0 rgba(79, 79, 119, 0.18);
                a span {
                    font-size: 15px;
                    line-height: 18px;
                }
            `,
            head: css`
                th:first-child {
                    ${stickyMode}
                }
            `,
            cell: css`
                padding: 22px 12px;
                border-bottom-color: ${getColor("common.ui9")};
                background-color: ${getColor("common.white")};
                &:first-child {
                    ${stickyMode}
                }
                a {
                    span {
                        color: ${getColor("common.ui1")} !important;
                        font-weight: 300 !important;
                    }
                }
            `,
        },
        cellTypographyProps: {
            size: 15,
        },
    },
} as xBaseTheme["dataTable"];
